const SESSION_STORAGE_KEYS = [
  'userInfo',
  'userAvatar',
  'resumeData',
  'resumeParsed',
  'resume_id',
  'cv_url',
  'cv_name',
  'jd_url',
  'jd_name',
  'jobInformation',
  'interviewSource'
]

export function clearUserSessionStorage() {
  SESSION_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key)
  })
}

